/**
 * Décode une polyline encodée Google (précision 5) en points [latitude, longitude].
 * L'ordre [lat, lng] est directement compatible Leaflet — ne pas inverser ensuite.
 * @see https://developers.google.com/maps/documentation/utilities/polylinealgorithm
 */
export const decodePolyline = (encoded: string): [number, number][] => {
  if (!encoded) return [];

  const points: [number, number][] = [];
  let index = 0,
    lat = 0,
    lng = 0;

  while (index < encoded.length) {
    let result = 0,
      shift = 0,
      byte: number;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    lat += result & 1 ? ~(result >> 1) : result >> 1;

    result = 0;
    shift = 0;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    lng += result & 1 ? ~(result >> 1) : result >> 1;

    points.push([lat / 1e5, lng / 1e5]);
  }

  return points;
};

// Formatage de secours si les textes serveur (distanceText/durationText) sont vides.
export const formatDistance = (text: string, meters: number): string =>
  text || `${(meters / 1000).toFixed(1).replace(".", ",")} km`;

export const formatDuration = (text: string, seconds: number): string =>
  text || `${Math.round(seconds / 60)} min`;
